import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Inputs,
  DatePickerComponent,
  AutocompleteComponent,
  FilesUploader,
  Spinner,
} from '../../../../../../Components';
import {
  getErrorByName,
  showError,
  showSuccess,
} from '../../../../../../Helper';
import {
  AddVendorClientTrackingDocuments,
  DeleteVendorClientTrackingDocument,
  GetVendorClientTrackingDocuments,
} from '../../../../../../Services';

export const ClientsTrackingContentDialog = ({
  data,
  state,
  setState,
  selected,
  setSelected,
  translationPath,
  parentTranslationPath,
  isSubmitted,
  schema,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const onChangeHandler = (key, values, selectedObj, selectedValues) => {
    if (!selectedObj) {
      setState({ id: [key], value: values });
    } else {
      setState({ id: [key], value: values });
      setSelected({ id: [selectedObj], value: selectedValues });
    }
  };
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleFilesUploaded = (files) => {
    setUploadedFiles(files);
  };

  const GetVendorClientTrackingById = async () => {
    setIsLoading(true);
    const res = await GetVendorClientTrackingDocuments(
      state.vendorClientTrackingId,
      1,
      999999
    );
    if (res) {
      const filesBuffer =
        res?.result?.map((item) => ({
          id: item.vendorClientTrackingDocumentId,
          fileName: item.fileName,
          uuid: item.fileId || item.uuid || null,
          url: item.fileUrl || item.url || null,
          vendorClientTrackingDocumentId:
            item.vendorClientTrackingDocumentId || null,
        })) || [];
      setUploadedFiles(filesBuffer);
    }
    setIsLoading(false);
  };

  const AddNewVendorClientTrackingDocuments = async (files) => {
    setIsLoading(true);

    const processedFiles = files || [];
    const validFiles = processedFiles.filter((element) => element.uuid);

    const documentsBuffer = validFiles.map((element) => ({
      fileName: element.fileName,
      fileId: element.uuid,
    }));

    if (documentsBuffer.length > 0) {
      const body = {
        vendorClientTrackingId: state.vendorClientTrackingId,
        documents: documentsBuffer,
      };

      const res = await AddVendorClientTrackingDocuments(body);
      if (res) {
        setTimeout(() => {
          GetVendorClientTrackingById();
        }, 500);
        showSuccess(t('documents-added-successfully'));
      } else {
        setIsLoading(false);
        showError(t('documents-addition-failed-error'));
      }
    }
  };

  const DeleteVendorClientTrackingDocumentByDocumentId = async (file) => {
    setIsLoading(true);
    if (file.vendorClientTrackingDocumentId) {
      const res = await DeleteVendorClientTrackingDocument(
        file.vendorClientTrackingDocumentId
      );
      if (res) {
        showSuccess(t('document-deleted-successfully'));
        GetVendorClientTrackingById();
      } else {
        setIsLoading(false);
        showError(t('document-deletion-failed-error'));
      }
    }
  };

  useEffect(() => {
    if (state.vendorClientTrackingId) {
      GetVendorClientTrackingById();
    }
  }, [state]);

  return (
    <>
      <Spinner isActive={isLoading || isUploading} isAbsolute={true} />
      <div className='d-flex flex-wrap justify-content-between'>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='serviceidRef'
            labelValue={t(`service-id`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.serviceId}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='serviceNameRef'
            labelValue={t(`service-name`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.serviceName || ''}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='clientidRef'
            labelValue={t(`client-id`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.contactId || ''}
          />
        </div>

        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='clientNameRef'
            labelValue={t(`client-name`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.contactName}
          />
        </div>

        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='vendorName'
            labelValue={t(`vendor-name`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.vendorName || ''}
          />
        </div>

        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='vendorIdRef'
            labelValue={t(`vendor-id`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.vendorId}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='vendorOfferNameRef'
            labelValue={t(`vendor-offer`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.vendorOfferName}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <DatePickerComponent
            idRef='createdOnRef'
            labelValue='creation-on'
            placeholder='DD/MM/YYYY'
            value={state?.createdOn || ''}
            parentTranslationPath={parentTranslationPath}
            isDisabled
            translationPath={translationPath}
            onDateChanged={(newValue) => {}}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='serviceCategoryRef'
            labelValue={t(`service-category`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.vendorServiceCategoryName || ''}
          />
        </div>

        <div className='mt-2 w-50'>
          <AutocompleteComponent
            idRef='psiCommissionStatusRef'
            labelClasses='Requierd-Color'
            labelValue='psi-commission-status'
            selectedValues={selected?.psiCommissionStatus}
            multiple={false}
            data={data?.psiCommissionStatus || []}
            displayLabel={(option) => option.lookupItemName || ''}
            getOptionSelected={(option) =>
              option.lookupItemId === state?.psiCommissionStatusId
            }
            withoutSearchButton
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            onChange={(event, newValue) => {
              onChangeHandler(
                'psiCommissionStatusId',
                newValue?.lookupItemId || null,
                'psiCommissionStatus',
                newValue
              );
            }}
            isSubmitted={isSubmitted}
            helperText={getErrorByName(schema, 'psiCommissionStatusId').message}
            error={getErrorByName(schema, 'psiCommissionStatusId').error}
            isWithError
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='psiCommissionPercentageteRef'
            labelValue={t(`psi-commission-percentagete`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.psiCommissionPercentage || ''}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='discountPercentageRef'
            labelValue={t(`discount-percentage`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.discountPercentage || ''}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <AutocompleteComponent
            idRef='transactionStatusClientTrackingRef'
            labelClasses='Requierd-Color'
            labelValue='transaction-status'
            selectedValues={selected?.transactionStatus}
            multiple={false}
            data={data?.transactionStatusClientTracking || []}
            displayLabel={(option) => option.lookupItemName || ''}
            getOptionSelected={(option) =>
              option?.lookupItemId === state?.transactionStatusId
            }
            withoutSearchButton
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            onChange={(event, newValue) => {
              onChangeHandler(
                'transactionStatusId',
                newValue?.lookupItemId || null,
                'transactionStatus',
                newValue
              );
            }}
            isSubmitted={isSubmitted}
            helperText={getErrorByName(schema, 'transactionStatusId').message}
            error={getErrorByName(schema, 'transactionStatusId').error}
            isWithError
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='invoiceNumberRef'
            labelValue={t(`invoice-number`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            value={state?.invoiceId || ''}
            type='number'
            min={0}
            onInputChanged={(event) => {
              let value = event && event.target && event.target.value;
              if (value && value !== '' && parseInt(value) < 0) {
                value = parseInt(value) * -1;
              }
              onChangeHandler(
                'invoiceId',
                value === '' ? null : parseInt(value) || null
              );
            }}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='transactionAmountRef'
            labelValue={t(`transaction-amount`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            value={state?.transactionAmount || ''}
            type='number'
            withNumberFormat
            onInputChanged={(event) => {
              let value = event && event.target && event.target.value;
              if (value && value !== '' && parseFloat(value) < 0) {
                value = parseFloat(value) * -1;
              }
              onChangeHandler(
                'transactionAmount',
                value === '' ? null : parseFloat(value) || null
              );
            }}
          />
        </div>
        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='qrCodeRef'
            labelValue={t(`qr-code`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.qrCode || ''}
          />
        </div>

        <div className='px-2 mt-2 w-50'>
          <Inputs
            idRef='promoCodeRef'
            labelValue={t(`promo-code`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            isDisabled
            value={state?.promoCode || ''}
          />
        </div>

        <div className='px-2 mt-2 w-100'>
          <Inputs
            idRef='clientFeedbackRef'
            labelValue={t(`client-feedback`)}
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            value={state?.clientFeedback || ''}
            rows={6}
            multiline={true}
            onInputChanged={(e) => {
              setState({
                id: 'clientFeedback',
                value: e?.target?.value || null,
              });
            }}
          />
        </div>

        <div className='px-2 mt-2 w-100'>
          <FilesUploader
            accept='application/pdf,image/jpeg,image/png'
            multiple={true}
            initUploadedFiles={uploadedFiles}
            uploadedChanged={handleFilesUploaded}
            setIsUploading={setIsUploading}
            uploadingHandler={AddNewVendorClientTrackingDocuments}
            onItemRemoved={DeleteVendorClientTrackingDocumentByDocumentId}
          />
        </div>
      </div>
    </>
  );
};
